import { Component, EventEmitter, Output } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { NgIf, LowerCasePipe } from '@angular/common'
import { ButtonComponent } from '@components/button/button.component'

@Component({
  selector: 'app-natural-stone-tutorial-modal',
  standalone: true,
  imports: [TranslateModule, NgIf, LowerCasePipe, ButtonComponent],
  templateUrl: './natural-stone-tutorial-modal.component.html',
  styleUrl: './natural-stone-tutorial-modal.component.scss'
})
export class NaturalStoneTutorialModalComponent {

    @Output() closedEvent = new EventEmitter<void>()

    currentStep = 1
    totalSteps = 3

    readonly steps = [
        {
            titleKey: 'natural_stone.tutorial_step_1_title',
            descriptionKey: 'natural_stone.tutorial_step_1_description',
            video: 'https://assetsstatic.cosentino.com/we/video/natural_stone_tutorial_step1.mp4'
        },
        {
            titleKey: 'natural_stone.tutorial_step_2_title',
            descriptionKey: 'natural_stone.tutorial_step_2_description',
            video: 'https://assetsstatic.cosentino.com/we/video/natural_stone_tutorial_step2.mp4'
        },
        {
            titleKey: 'natural_stone.tutorial_step_3_title',
            descriptionKey: 'natural_stone.tutorial_step_3_description',
            video: 'https://assetsstatic.cosentino.com/we/video/natural_stone_tutorial_step3.mp4'
        }
    ]

    get currentStepData() {
        return this.steps[this.currentStep - 1]
    }

    next() {
        if (this.currentStep < this.totalSteps) {
            this.currentStep++
        } else {
            this.currentStep = 1
            this.closedEvent.emit()
        }
    }

    back() {
        if (this.currentStep > 1) {
            this.currentStep--
        }
    }

    isLastStep() {
        return this.currentStep === this.totalSteps
    }
}
